import React from 'react'
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, InputLabel, List, ListItem, ListItemAvatar, ListItemText, MenuItem, Select, Slide } from '@material-ui/core'
import ArrowBackIcons from "@material-ui/icons/ArrowBack"
import { makeStyles } from '@material-ui/core/styles';
import { Switch } from 'react-router';
import { Link } from 'react-router-dom';
import './Connect.css'


function Connect(props) {
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState();
  
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };
    

    return (
        <div className="Connect">
            <div className="container">
                <div className="sectionHeader">
                    <Link to="/" className="backBtn"><ArrowBackIcons /> Back to Home</Link>
                    <h1 className="sectionHeaderText">Connect your wallet</h1>
                </div>
                <div className="sectionForAction">
                    <React.Fragment>
                    <Button className="startToConnect" variant="outlined" color="primary" onClick={handleClickOpen}>
                        Connect with wallet
                    </Button>
                    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
                        <DialogTitle id="simple-dialog-title">Pick a wallet to connect</DialogTitle>
                            <List>
                                <Link to="/">
                                    <ListItem >
                                        <ListItemAvatar>
                                            <Avatar />
                                        </ListItemAvatar>
                                        <ListItemText primary="Metamask" />
                                    </ListItem>
                                </Link>
                                <Link to="/">
                                    <ListItem >
                                        <ListItemAvatar>
                                            <Avatar />
                                        </ListItemAvatar>
                                        <ListItemText primary="Fortmatic" />
                                    </ListItem>
                                </Link>
                            </List>
                        </Dialog>
                    </React.Fragment>
                </div>
                
            </div>
        </div>
    )
}

export default Connect
